import { Box, Paper, Typography } from "@mui/material";

export const JsonPanel = ({ title, value }: { title: string; value: unknown }) => {
  const json = JSON.stringify(value ?? {}, null, 2) ?? "";
  const tokens = json.split(
    /("(?:\\.|[^"\\])*"\s*:|"(?:\\.|[^"\\])*"|-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?|true|false|null)/g
  );

  return (
    <Paper variant="outlined" sx={{ minWidth: 0, width: "100%", overflow: "hidden" }}>
      <Typography variant="subtitle1" fontWeight={600} sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: "divider" }}>
        {title}
      </Typography>
      <Box
        component="pre"
        aria-label={title}
        tabIndex={0}
        sx={{
          m: 0,
          p: 2,
          maxHeight: 520,
          overflow: "auto",
          whiteSpace: "pre",
          fontFamily: "Monaco, Menlo, Consolas, monospace",
          fontSize: 12,
          lineHeight: 1.7,
          bgcolor: (theme) => (theme.palette.mode === "dark" ? "grey.900" : "grey.50"),
          color: "text.secondary",
          "& .json-key": { color: (theme) => (theme.palette.mode === "dark" ? "#79c0ff" : "#006eb8") },
          "& .json-string": { color: (theme) => (theme.palette.mode === "dark" ? "#7ee787" : "#00852b") },
          "& .json-number": { color: (theme) => (theme.palette.mode === "dark" ? "#ffa198" : "#c62828") },
          "& .json-literal": { color: (theme) => (theme.palette.mode === "dark" ? "#d2a8ff" : "#7b1fa2") },
        }}
      >
        <code>
          {tokens.map((token, index) => {
            const kind = token.startsWith('"')
              ? token.endsWith(":")
                ? "key"
                : "string"
              : /^(true|false|null)$/.test(token)
              ? "literal"
              : /^-?\d/.test(token)
              ? "number"
              : undefined;
            return (
              <span key={index} className={kind ? `json-${kind}` : undefined}>
                {token}
              </span>
            );
          })}
        </code>
      </Box>
    </Paper>
  );
};
